// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Carousel_sliderWrapper__2ZS37","slider":"Carousel_slider__wSE3U"};